import { gql } from 'graphql-request';

export const UPDATE_ME_MUTATION = gql`
  mutation UpdateMe($input: UpdateMeInput!) {
    updateMe(input: $input) {
      id
      name
      surname
      fullName
      email
      profilePictureLocation
    }
  }
`;
